import Backbone from 'backbone';
import Question from './Question';

var QuestionCollection = Backbone.Collection.extend({
    model: Question

});

export default QuestionCollection;

